export default __webpack_public_path__ + "assets/png/f05ff4c3b7090688c85a41c1dab76270.png";